<template>
  <div>
    <section class="py-5 section-bubble1"></section>
    <div
      class="mb-n10"
      height="600"
      color="#FBD1B9"
      style="background: #f8b58e"
    >
      <!-- <div class="svg-border-waves">
        <img src="~@/assets/borderWaves.svg" />
      </div> -->
      <base-section
        :height="$vuetify.breakpoint.mdAndUp ? '500px' : '500px'"
        id="customer-reviews"
        class="mt-n2"
      >
        <div class="pt-13 text-center">
          <!-- <div
            class="text-uppercase font-weight-bold body-2 secondary--text mb-2"
          >
            Testimonials
          </div> -->
          <h2
            style="font-weight: 400 !important"
            class="text-h5 black--text text-lg-h4"
          >
            The talk of the town
          </h2>
        </div>

        <v-carousel hide-delimiters class="mt-n16" height="480" light>
          <v-carousel-item v-for="(customer, i) in customers" :key="i">
            <v-container class="fill-height">
              <v-responsive
                class="mx-auto shrink text-center"
                max-width="90%"
                width="700"
              >
                <base-body
                  :text="customer.quote"
                  tag="em"
                  class="mb-6 mt-n1 black--text d-block"
                />

                <v-avatar class="mb-6" size="128">
                  <base-img :src="require(`@/assets/${customer.avatar}`)" />
                </v-avatar>

                <base-title
                  class="black--text"
                  :title="customer.name"
                  space="0"
                />

                <!-- <base-subtitle :title="customer.role" /> -->
              </v-responsive>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </base-section>
    </div>
    <svg
      class="separator mt-8"
      width="105%"
      height="100"
      viewBox="0.1 0.1 180 40"
      preserveAspectRatio="none"
    >
      <g transform="translate(-18.298844,-77.973964)">
        <path
          style="fill: #b22af0"
          d="M 31.615583,86.351641 H 192.16499 v 26.901969 c 0,0 -32.03411,-14.237983 -59.62682,-12.72484 -22.34188,1.2252 -54.779359,9.72634 -54.779359,9.72634 0,0 -22.029534,3.62882 -34.471238,-1.88988 -12.441702,-5.51871 -11.67199,-22.013589 -11.67199,-22.013589 z"
        />
        <path
          style="fill: #f8b58e"
          d="M 18.441597,78.106256 H 198.58126 v 39.288614 c 0,0 -43.10672,-27.825245 -73.47599,-19.687823 -30.369264,8.137423 -46.832208,12.548653 -46.832208,12.548653 0,0 -32.775418,8.05972 -46.735258,0 C 17.577964,102.19598 18.441597,78.106256 18.441597,78.106256 Z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SectionCustomerReviews',

  provide: {
    heading: { align: 'center' },
  },

  data: () => ({
    customers: [
      {
        quote:
          '"Super concept and seamless  functionality! Highly recommended."',
        name: 'Julie Tobiansky ',
        // company: 'Motion',
        avatar: 'julie.jpg',
      },
      {
        quote:
          '"The Strapp platform is professionally & securely put together and super easy to use. My items were loaded quickly and I am really impressed with the service so far! Highly recommend."',
        name: 'Lisa-Marie Cheketri ',
        // company: 'Classic Cafe',
        avatar: 'lisa.jpg',
      },
      {
        quote:
          '"Professional, easy, secure and safe, the item was high quality and the process seamless."',
        name: 'Fadeelah Adams',
        //  company: 'Flagship',
        avatar: 'fadeelah.jpg',
      },
      {
        quote: '"Great Service and very trustworthy! Highly recommend."',
        name: 'Jessica McIntosh ',
        //  company: 'Flagship',
        avatar: 'jess.jpg',
      },
    ],
  }),
};
</script>

<style lang="sass">
#customer-reviews
  .v-carousel__controls
    background: transparent

  .base-body
    line-height: 2
</style>

<style scoped>
.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
  z-index: -1;
}

.seperator {
  margin-top: 50px;
}

.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}
</style>

<style lang="scss">
$spacer-height: 20vw;
$section1-bg-color: #fff;
$section2-bg-color: #f8b58e;
$section3-bg-color: #384364;
$section4-bg-color: #cccccc;
$section5-bg-color: #333333;

@mixin bubbles($bubbles-type, $color) {
  @if $bubbles-type == a {
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='#{url-friendly-colour($color)}' viewBox='0 0 1185 248'><circle cx='76' cy='121.1' r='20' class='a'/><circle cx='870' cy='201.1' r='11' class='a'/><circle cx='814.5' cy='165.6' r='24.5' class='a'/><path d='M0 0v17.7c22.7 14.8 53 31.9 90.7 51.5 150.8 78 322 116.6 424.8 69.3 102.9-47.4 138-69.3 210.8-69.3s118.3 48.6 219.5 38.3 76.3-59.3 188.7-59.3c18.9 0 35.5 2.6 50.5 6.8V0H0z' class='a'/></svg>");
  } @else if $bubbles-type == b {
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1185 248'><path d='M50.5 199.8c112.4 0 87.5-49 188.7-59.3s146.7 38.3 219.5 38.3 107.9-21.9 210.8-69.3c102.8-47.3 274-8.7 424.8 69.3 37.7 19.5 68 36.7 90.7 51.5V0H0v193C15 197.2 31.6 199.8 50.5 199.8zM1109 106.9c11 0 20 9 20 20 0 11-9 20-20 20s-20-9-20-20C1089 115.9 1098 106.9 1109 106.9zM370.5 57.9c13.5 0 24.5 11 24.5 24.5 0 13.5-11 24.5-24.5 24.5S346 95.9 346 82.4C346 68.9 357 57.9 370.5 57.9zM315 35.9c6.1 0 11 4.9 11 11s-4.9 11-11 11 -11-4.9-11-11S308.9 35.9 315 35.9z' fill='#{url-friendly-colour($color)}'/></svg>");
  }
}

@mixin section-bubble-with-colors($bubble-type, $currentcolor, $nextcolor) {
  @extend .section-bubble;
  background-color: $currentcolor;

  &:after {
    background-color: $nextcolor;

    @include bubbles($bubble-type, $currentcolor);
  }
}

@function url-friendly-colour($colour) {
  @return '%23' + str-slice('#{$colour}', 2, -1);
}

.section-bubble {
  margin-bottom: $spacer-height;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    height: 10%;
    width: 100%;
    height: $spacer-height;
    background: green; // needs to be next sections background
    background-size: 100%;

    transform: translate(0, 100%);
  }
}

.section-bubble1 {
  @include section-bubble-with-colors(
    a,
    $section1-bg-color,
    $section2-bg-color
  );
}
</style>
